import ProgressBar from "../progressBar";


function CourseActivityBlock(props) {

  // Define variables
  const title = props.title;
  const percent = props.percent;
  const lessonComplete = props.lessonComplete;
  const lessonTotal = props.lessonTotal;
  const score = props.score;


  // Screen components
  let scoreElement;
  if( score ) {
    scoreElement = (
      <span>&nbsp;|&nbsp; score {score}%</span>
    );
  }


  return (
    <div>
      <p>{title}</p>
      <div class='flex-row' style={{justifyContent: 'flex-start'}}>
        <ProgressBar percent={percent} />
        <p class="gray-text seconday-info">
          {lessonComplete}<span>/</span>{lessonTotal}
          {scoreElement}
        </p>
      </div>
    </div>
  );
}

export default CourseActivityBlock;